export const errorCodes = {
  TIMESLOT_NOT_AVAILABLE: "TIMESLOT_NOT_AVAILABLE",
  NO_TIMESLOTS_AVAILABLE: "NO_TIMESLOTS_AVAILABLE",
  TIMESLOT_CAPACITY_REACHED: "TIMESLOT_CAPACITY_REACHED",
  TIMESLOT_MAX_CAPACITY_REACHED: "TIMESLOT_MAX_CAPACITY_REACHED",
  UNKNOWN_USER_OR_WRONG_PASSWORD: "unknown_user_or_wrong_password",
  USER_EXISTS: "user_exists",
  ERROR_ADDED_BY_ANOTHER_USER: "ERROR_ADDED_BY_ANOTHER_USER",
  NOT_FOUND: "not_found",
  // PROMOTION CODES START
  CODE_IS_NO_LONGER_VALID: "code_is_no_longer_valid",
  CODE_ALREADY_USED: "code_already_used",
  CUSTOMER_ALREADY_ADDED: "customer_already_added",
  CODE_NOT_FOUND: "code_not_found",
  RESOURCE_NOT_FOUND: "resource_not_found",
  ITEM_NOT_FOUND: "item_not_found",
  PROMOTION_CODE_NOT_FOUND: "promotion_code_not_found",
  PARTNERSHIP_NOT_FOUND: "partnership_not_found",
  REDEEM_LIMIT_REACHED: "redeem_limit_reached",
  USER_PHONE_NOT_VERIFIED: "user_phone_not_verified",
  USER_ORDER_ALREADY_PLACED: "user_order_already_placed",
  USER_PHONE_ALREADY_VERIFIED: "user_phone_already_verified",
  VALIDATION_ERROR: "validation_error",
  // PROMOTION CODES END
}
